import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';


const CardDelivery = (props) => {
    return (
        <Card sx={{ minWidth: 275 }}>
            <CardContent>
                <Typography sx={{ fontSize: 14 }} color="#000000" gutterBottom>
                    Сведения о доставке
                </Typography>

                <Typography sx={{ mb: 0 }} color="text.secondary">
                    Тип доставки: {props.Type}
                </Typography>
                <Typography sx={{ mb: 0 }} color="text.secondary">
                    Адрес: {props.Adress}
                </Typography>

                <Typography sx={{ mb: 0 }} color="text.secondary">
                    Телефон: {props.Phone}
                </Typography>

                <Typography sx={{ mt: 1 }} color="#000000">
                    Стоимость: {props.Price}  ₽
                </Typography>
            </CardContent>
        </Card>
    );
};

export default CardDelivery;